// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"cc163084","897":"cc163084"}[chunkId] + ".chunk.css";
};